import { trackEvent } from './googleAnalytics'

/**
 * Represents an event with a category and action.
 */
interface EventType {
    category: string
    action: string
}

/**
 * Determines if a URI is an HTTP or HTTPS URL.
 * @param uri - The URI to check.
 * @returns True if the URI uses HTTP or HTTPS, otherwise false.
 */
function isHttpUri(uri: string) {
    let url

    try {
        url = new URL(uri)
    } catch {
        return false
    }

    return ['https:', 'http:'].includes(url.protocol)
}

/**
 * Navigates to a specified URI, opening HTTP URLs in new window and hash navigation for everything else.
 * Optionally tracks the navigation event.
 * @param targetUri - The URI to navigate to.
 * @param event - Optional event object to track the navigation.
 */
export default function navigate(targetUri: string, event?: EventType) {
    if (event) {
        trackEvent(event.category, event.action, targetUri)
    }

    if (isHttpUri(targetUri)) {
        window.open(targetUri)
    } else {
        window.location.hash = targetUri
    }
}
